import { constructEnum } from '@/lib/enum';

export default constructEnum('PaginationMethod', {
  NONE: -1,
  SEE_MORE: 10,
  SEE_ALL: 15,
  INFINITE_SCROLL: 20,
  PAGINATE: 0
});
